const BREAK_POINT_SCREEN = 1280;

export const isMobileScreen = ():boolean => {
	return window.innerWidth < BREAK_POINT_SCREEN;
}

 